<template>
  <p>
    El pluviómetro de peso registra la variable precipitación, cuyo valor se
    expresa en mm/min. A diferencia de los pluviómetros balancín, el instrumento
    acumula la precipitación en el recipiente colector, incrementando el peso
    del recipiente y este cambio es detectado y convertido en una medida de la
    cantidad de precipitación. La micro balanza es bastante sensible pudiendo
    registrar como mínimo 0.01mm. Esta peculiaridad tiene su ventaja al poder
    registrar las precipitaciones sólidas como granizo y nieve.
  </p>
  <img
    class="thumbnail instrument"
    src="@/assets/images/microfisica/instrumentos/pluviometro.webp"
    alt="Pluviómetro"
  />

  <p>
    <b>
      Variables más importantes que registra:
    </b>
  </p>
  <List marked>
    <li>Intensidad de precipitación (mm/min)</li>
    <li>Precipitación acumulada total (mm)</li>
    <li>Contenido del recipiente en tiempo real (mm)</li>
  </List>

  <p>
    <b>Marca y modelo: </b> <br />
    OTT Hydromet, Pluvio<sup>2</sup> S
  </p>

  <p>
    <b>País: </b> <br />
    Alemania
  </p>

  <p>
    <b>Especificaciones técnicas: </b> <br />
    <a
      href="https://www.ott.com/es-la/productos/download/instrucciones-de-funcionamiento-sensor-de-precipitaciones-ott-pluvio2-s-2/"
      target="_blank"
      >https://www.ott.com/es-la/productos/download/instrucciones-de-funcionamiento-sensor-de-precipitaciones-ott-pluvio2-s-2/</a
    >
  </p>

  <p>
    <b>Responsable: </b> <br />
    jflores@igp.gob.pe
  </p>
</template>

<script>
import List from "@/components/ui/objects/List";
export default {
  setup() {
    const basePath = process.env.VUE_APP_PUBLIC_PATH;
    return {
      basePath,
    };
  },
  components: { List },
};
</script>
